/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useChannelOverlayContext } from '../../../hooks/useChannelOverlayContext';
import { QuickSetupComponentProps } from '../../../util/types';
import { messages as QuickSetupShared } from '../../common/quick-setup/messages';
import { QuickSetupProvider } from '../../common/quick-setup/QuickSetupProvider';
import { Step } from '../../common/quick-setup/Step';
import { AppInfoStep } from '../app-registration/AppInfoStep';
import { AppRegistrationMessages } from '../app-registration/messages';
import { EndpointStep } from '../endpoint-tab/EndpointStep';
import { EndpointMessages } from '../endpoint-tab/messages';
import { TeamsAppMessages } from '../teams-app/messages';
import { TeamsAppStep } from '../teams-app/TeamsAppStep';
import { IntroStep } from './IntroStep';

export const MicrosoftTeamsQuickSetup = ({
  assistantId,
  environmentId,
  readOnly
}: QuickSetupComponentProps) => {
  const { formatMessage: t } = useIntl();
  const { buttonHooks, setShowNextBack } = useChannelOverlayContext();

  useEffect(() => {
    setShowNextBack(true);
  }, [setShowNextBack]);

  return (
    <div>
      <QuickSetupProvider readOnly={readOnly} buttonHooks={buttonHooks}>
        <Step label={t(QuickSetupShared.getStarted)}>
          <IntroStep />
        </Step>
        <Step
          label={t(AppRegistrationMessages.appRegistration)}
          required={true}>
          <AppInfoStep readOnly={readOnly} />
        </Step>
        <Step label={t(EndpointMessages.createYourBot)} required={true}>
          <EndpointStep
            assistantId={assistantId}
            environmentId={environmentId}
          />
        </Step>
        <Step label={t(TeamsAppMessages.createYourTeamsApp)} required={true}>
          <TeamsAppStep />
        </Step>
      </QuickSetupProvider>
    </div>
  );
};
